// DO NOT MODIFY THIS FILE
// THIS IS A SNAPSHOT OF SUPPORTED ADVANCED SEARCH SCHEMA AT A SPECIFIC VERSION
// IF YOU NEED TO CHANGE THE STRUCTURE OF THE SCHEMA, MAKE A NEW VERSION

import {
  ConjunctionV3,
  DatatypeOperatorTypeV3,
  DirectionV3,
  InstanceOperatorTypeV3,
  ObjectOperatorTypeV3,
  OperatorTypeV3,
  XSD_DATATYPE_IRIS_V3,
} from 'bones/utils/queryBuilder/migrate/v3/constants';

export const OPERATOR_V3_SCHEMA = {
  type: 'object',
  required: ['iri', 'type', 'operatorType'],
  properties: {
    iri: { type: 'string' },
    operatorType: {
      enum: [
        OperatorTypeV3.INSTANCE,
        OperatorTypeV3.DATATYPE,
        OperatorTypeV3.OBJECT,
      ],
    },
  },
  oneOf: [
    {
      properties: {
        type: { enum: Object.values(InstanceOperatorTypeV3) },
      },
    },
    {
      properties: {
        direction: { enum: [DirectionV3.INBOUND, DirectionV3.OUTBOUND] },
        type: { enum: Object.values(ObjectOperatorTypeV3) },
      },
      required: ['direction'],
    },
    {
      properties: {
        comparison: { type: 'boolean' },
        range: { enum: [...XSD_DATATYPE_IRIS_V3, null] },
        type: { enum: Object.values(DatatypeOperatorTypeV3) },
      },
      required: ['range'],
    },
  ],
};

export const VARIABLE_V3_SCHEMA = {
  type: 'object',
  required: ['id', 'iri'],
  properties: {
    id: { type: 'string' },
    iri: { type: 'string' },
  },
};

export const STRING_OR_VARIABLE_V3 = {
  oneOf: [{ type: 'string' }, VARIABLE_V3_SCHEMA],
};

export const FILTER_V3_SCHEMA = {
  type: 'object',
  required: ['subject', 'operator'],
  properties: {
    subject: VARIABLE_V3_SCHEMA,
    operator: OPERATOR_V3_SCHEMA,
  },
  oneOf: [
    {
      properties: {
        value: STRING_OR_VARIABLE_V3,
      },
      required: ['value'],
    },
    {
      properties: {
        comparisonSubject: VARIABLE_V3_SCHEMA,
        comparisonOperator: OPERATOR_V3_SCHEMA,
      },
      required: ['comparisonSubject', 'comparisonOperator'],
    },
  ],
};

export const EXPRESSION_V3_SCHEMA = {
  type: 'object',
  required: ['filters'],
  properties: {
    filters: {
      type: 'array',
      items: FILTER_V3_SCHEMA,
    },
  },
};

export const SUB_EXPRESSION_V3_SCHEMA = {
  type: 'object',
  required: ['expressions', 'conjunction'],
  properties: {
    expressions: {
      type: 'array',
      items: EXPRESSION_V3_SCHEMA,
    },
    conjunction: { enum: [ConjunctionV3.AND] },
  },
};

export const TOP_EXPRESSION_V3_SCHEMA = {
  type: 'object',
  required: ['expressions', 'conjunction'],
  properties: {
    expressions: {
      type: 'array',
      items: SUB_EXPRESSION_V3_SCHEMA,
    },
    conjunction: { enum: [ConjunctionV3.OR] },
  },
};

export const DATA_V3_SCHEMA = {
  type: 'object',
  properties: {
    fullGraph: { type: 'boolean' },
    query: TOP_EXPRESSION_V3_SCHEMA,
  },
  additionalProperties: false,
  required: ['fullGraph', 'query'],
};
